import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { PortfolioGrowth } from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { Constants } from '../../../../shared/classes/constants';

@Component({
	selector: 'app-growth-chart',
	templateUrl: './growth-chart.component.html',
	styleUrls: ['./growth-chart.component.scss']
})
export class GrowthChartComponent implements OnInit {
	//#region Fields
	bindingContext: BindingContext = new BindingContext();
	_rawData: Array<PortfolioGrowth>;
	_currentTabName: string;
	chartDataM: ChartData = new ChartData();
	chartDataY: ChartData = new ChartData();

	get rawData(): Array<PortfolioGrowth> {
		return this._rawData;
	}

	set rawData(input: Array<PortfolioGrowth>) {
		this._rawData = input;
	}
	get currentTabName(): string {
		return this._currentTabName;
	}

	@Input()
	set currentTabName(input: string) {
		this._currentTabName = input;
		let months: number = Constants.ReportingTimePeriodEnum.Monthly;
		if ('Y' === input) {
			months = Constants.ReportingTimePeriodEnum.Yearly;
		}
		this.getDashboardData(months);
	}

	chartColors: any[] = [
		{
			backgroundColor: this.getColors()
		}
	];
	//#endregion

	//#region Construction
	constructor(private dashboardSvc: DashboardService) {}

	ngOnInit() {}
	//#endregion

	getColors(): Array<string> {
		const result = new Array<string>();
		for (let i = 0; i < 2; i++) {
			result.push(
				'#945DA6',
				'#BC692E',
				'#F6A335',
				'#B42991',
				'#75A842',
				'#AEE1FA'
			);
		}
		return result;
	}

	public getRandomColors(num: number = 1): string[] {
		const allowedColors = [
			'#1BAE99', // green
			'#33488D', // dark blue
			'#6C8CC8', // light blue
			'#58585A', // dark grey
			'#99A0A5', // light grey
			'#5E2D8D', // purple
			'#ff0000' // red
		];
		const colors = [];
		while (colors.length < num) {
			const newColor =
				allowedColors[Math.floor(Math.random() * allowedColors.length)];
			// make sure there aren't adjoining colors
			if (colors.length === 0 || newColor !== colors[colors.length - 1]) {
				colors.push(newColor);
			}
		}
		return colors;
	}

	populateDataSet() {
		this.chartDataM = new ChartData();
		this.chartDataY = new ChartData();

		for (let i = 0; i < 2; ++i) {
			const data = new Array<number>();
			let chartData: ChartData = this.chartDataM;
			if (i === 1) {
				chartData = this.chartDataY;
			}

			this.rawData.filter((item: PortfolioGrowth) => {
				const filter = i === 0 ? 'M' : 'Y';
				if (item.Scale === filter) {
					data.push(item.OpenMerchants);
					chartData.labels.push(this.getKey(item, filter));
					return item;
				}
			});

			const ds = { label: 'Growth', data: data };
			chartData.dataset = ds;
		}
	}

	getKey(item: PortfolioGrowth, reportingTimePeriod: string): string {
		let result: string = null;
		let date: Date;
		date = new Date(Date.parse(item.EndDate.toString()));
		if (reportingTimePeriod === 'M') {
			const month = date.getMonth();
			result = this.toMonthString(month);
		} else {
			result = date.getFullYear().toString();
		}
		return result;
	}

	toMonthString(month: number): string {
		let result = '';
		switch (month) {
			case 0:
				result = 'Jan';
				break;
			case 1:
				result = 'Feb';
				break;
			case 2:
				result = 'Mar';
				break;
			case 3:
				result = 'Apr';
				break;
			case 4:
				result = 'May';
				break;
			case 5:
				result = 'Jun';
				break;
			case 6:
				result = 'Jul';
				break;
			case 7:
				result = 'Aug';
				break;
			case 8:
				result = 'Sep';
				break;
			case 9:
				result = 'Oct';
				break;
			case 10:
				result = 'Nov';
				break;
			case 11:
				result = 'Dec';
				break;
			default:
				console.log(month);
				break;
		}
		return result;
	}

	getDashboardData(months: number) {
		this.bindingContext.beginGet();
		this.dashboardSvc.getPortfolioGrowth().subscribe(
			(resp: PortfolioGrowth[]) => {
				let isValid = false;
				if (undefined !== resp && resp.length === 24) {
					isValid = true;
				}

				this.rawData = resp;
				if (isValid) {
					this.populateDataSet();
				}
				this.bindingContext.endGet(isValid);
			},
			(response: HttpErrorResponse) => {
				this.bindingContext.setError(response);
			}
		);
	}
} // class

export class ChartData {
	//#region Fields
	_datasets: Array<any> = new Array<any>();
	labels = new Array<string>();
	legend = false;
	chartType = 'bar';
	options = {
		scaleShowVerticalLines: false,
		responsive: true,
		scales: {
			yAxes: { display: false, ticks: { suggestedMin: 0 } },
			xAxes: { display: true, gridLines: { display: false } }
		}
	};
	//#endregion

	//#region Properties
	set dataset(input: any) {
		this._datasets.push(input);
	}

	get datasets(): Array<any> {
		const result = this._datasets;
		return result;
	}
	//#endregion

	constructor() {}
}
